var map = {
	"./10C.png": 45,
	"./10D.png": 46,
	"./10H.png": 47,
	"./10S.png": 48,
	"./2C.png": 49,
	"./2D.png": 50,
	"./2H.png": 51,
	"./2S.png": 52,
	"./3C.png": 53,
	"./3D.png": 54,
	"./3H.png": 55,
	"./3S.png": 56,
	"./4C.png": 57,
	"./4D.png": 58,
	"./4H.png": 59,
	"./4S.png": 60,
	"./5C.png": 61,
	"./5D.png": 62,
	"./5H.png": 63,
	"./5S.png": 64,
	"./6C.png": 65,
	"./6D.png": 66,
	"./6H.png": 67,
	"./6S.png": 68,
	"./7C.png": 69,
	"./7D.png": 70,
	"./7H.png": 71,
	"./7S.png": 72,
	"./8C.png": 73,
	"./8D.png": 74,
	"./8H.png": 75,
	"./8S.png": 76,
	"./9C.png": 77,
	"./9D.png": 78,
	"./9H.png": 79,
	"./9S.png": 80,
	"./AC.png": 81,
	"./AD.png": 82,
	"./AH.png": 83,
	"./AS.png": 84,
	"./JC.png": 85,
	"./JD.png": 86,
	"./JH.png": 87,
	"./JS.png": 88,
	"./KC.png": 89,
	"./KD.png": 90,
	"./KH.png": 91,
	"./KS.png": 92,
	"./QC.png": 93,
	"./QD.png": 94,
	"./QH.png": 95,
	"./QS.png": 96,
	"./backs-card/back_cards-07.png": 97,
	"./backs-card/blue_back.png": 98,
	"./backs-card/gray_back.png": 99,
	"./backs-card/green_back.png": 100,
	"./backs-card/honor_clubs.png": 101,
	"./backs-card/honor_diamond.png": 102,
	"./backs-card/honor_heart-14.png": 103,
	"./backs-card/honors_spade-14.png": 104,
	"./backs-card/purple_back.png": 105,
	"./backs-card/red_back.png": 23,
	"./backs-card/yellow_back.png": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;